import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  searchApiKey: string;
};

function mapResponse(response: ApiResponse) {
  return response.searchApiKey;
}

const endpoint = new FetchEndpoint({
  urlFactory: () => '/data/synonyms-api-key',
  mapResponse,
});

// Exports

export const apiClientFetchSynonymSearchApiKey = endpoint.client();

export const apiServerFetchSynonymSearchApiKey = endpoint.server();
